import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_4.jpg'
import Card from '../../UI/Card'


import './plans.css'
import { Alert, Button, CircularProgress, FormLabel, Modal, Snackbar, TextField, Typography } from '@mui/material'
import { useEffect, useState } from 'react';
import { Cancel } from '@mui/icons-material'
import { BiPackage } from 'react-icons/bi'
import axiosInstance from '../../utils/axiosInstance'

const Plans = () => {
  const api_link = process.env.REACT_APP_API_URL;
  const [open, setOpen] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [activePlan, setActivePlan] = useState({});
  const [message, setMessage] = useState('');
  const [start_date, setStartDate] = useState('')
  const [end_date, setEndDate] = useState('')
  const [loading, setLoading] = useState(true)
  const isAuthenticated = localStorage.getItem('gym_user') ? JSON.parse(localStorage.getItem('gym_user')) : null;
  const [plans, setPlans] = useState([{
    plan_id: '',
    title: '',
    price: '',
    duration: '',
    features: '',
    createdAt: ''
  }])

  const handleOpen = (plan) => {
    setOpen(true);
    setActivePlan(plan);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubscription = async () => {
    setOpenSnack(true);
    if (!isAuthenticated) {
      setMessage('Failure! You need to be logged in as a member or guest to subscribe.')
      return;
    }
    const payload = {
      membership_id: isAuthenticated.guest_id || isAuthenticated.member_id,
      plan_id: activePlan.plan_id,
      start_date: start_date,
      end_date: end_date,
      status: 'inactive'
    }

    await axiosInstance.post(`membershipsubscription/create`, payload, {
      headers: { 'Content-Type': 'application/json' }
    }).then(() => {
      setMessage(`Success! Successfully subscribed to ${activePlan.title}. Your subscription is under review and you will be notified for anything.`)
      setTimeout(() => {
        setOpenSnack(false);
        setActivePlan({})
        setOpen(false);
      }, 2000)
    }).catch((error) =>{
      console.error(error);
      setMessage('Failure! Failed to subscribe to the plan. Try again later.')
    })
  }

  useEffect(() => {
    const getPlans = async () => {
      setLoading(true);
      await axiosInstance.get(`plans/all`).then((response) => {
        setLoading(false);
        setPlans(response.data.data);
      }).catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.message === "No plans found") {
          setPlans([]);
        } else if (error.response && error.response.data.message !== "No plans found") {
          // console.error(error.response.data)
          setPlans([]);
        } else {
          setPlans([]);
          // console.log(error);
        }
      });
    }

    getPlans();
  }, [api_link])

  return (
    <>
      <Header title="Membership Plans" image={HeaderImage}>
        Reprehenderit dolorem totam aliquam minus.
        Reprehenderit dolorem totam aliquam minus.
        Reprehenderit dolorem totam aliquam minus.
      </Header>
      <div className='container flex items-center mt-10 text-3xl text-white gap-4'>
        <span className='bg-[#24245c] p-3 rounded-3xl px-5'><BiPackage className='text-[#c7b262] text-[3rem]' /></span>
        <span className='text-[2.4rem]'>Our Programs</span>
      </div>
      {loading ?
        <div className="flex justify-center items-center pt-20"><CircularProgress /></div>
      :
        <section className='plans mt-12'>
          <div className="container plans__container">
            {plans.length > 0 &&
              plans.map(({ plan_id, title, duration, price, features }) => {
                return <Card key={plan_id} className='plan'>
                  <h1>{title}</h1>
                  <div className='flex gap-2 justify-center items-baseline'>
                    <h2>{`Ugx ${price}`}</h2>/
                    <small>{duration}</small>
                  </div>
                  <Typography variant='h4'>Features</Typography>
                  {features.split(',').map((feature, index) => <p key={index}>{feature}</p>)}
                  <button className='btn lg' onClick={() => handleOpen({ plan_id, title, duration, price, features })}>Chose Plan</button>
                </Card>
              })}

            {/* features.split(',').map(({ feature, available }, index) => {
              return <p key={index} className={!available ? 'disabled' : ''}>
                {feature}</p>
            }) */}
          </div>

          {plans.length === 0 && <div className="w-[80%] text-red-500 font-bold text-center text-xl mx-auto py-4" style={{ border: '1px solid red' }}>Plans being generated, please be patient</div>}
        </section>
      }

      <Modal open={open} onClose={handleClose} className='flex items-center justify-center w-full border-2 border-red-500' aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <div className='bg-white w-[35%] shadow rounded-sm'>
          {isAuthenticated && (isAuthenticated.guest_id || !isAuthenticated.member_id) ?
            <div className='p-8'>
              <h2 className='text-blue-950 mb-8'>
                {`Join ${activePlan.title}`}
              </h2>
              <form>
                <FormLabel>Start Date</FormLabel>
                <TextField fullWidth type="date" value={start_date} variant="standard" style={{ marginBottom: '16px' }} onChange={(e) => setStartDate(e.target.value)} />
                <FormLabel>End Date</FormLabel>
                <TextField fullWidth type="date" value={end_date} variant="standard" style={{ marginBottom: '16px' }} onChange={(e) => setEndDate(e.target.value)} />
                <div className='flex gap-4 mx-auto w-[80%]'>
                  <Button variant="contained" color="primary" fullWidth onClick={handleSubscription}>
                    Submit
                  </Button>
                  <Button variant="contained" color="error" onClick={handleClose} fullWidth className='mt-4'>
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          :
            <div className="text-center text-blue-950">
              <div className="text-center flex justify-end text-blue-950">
                <Button color="error" onClick={handleClose} className='mt-4'>
                  <Cancel />
                </Button>
              </div>
              <p className='w-full p-8'>Login or create an account(if you don't have any) first to subscribe.</p>
            </div>
          }
        </div>
      </Modal>

      <Snackbar open={openSnack} autoHideDuration={10000} onClose={() => setOpenSnack(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
      </Snackbar>
    </>
  )
}

export default Plans